import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import {RouterStateUrl, SelectCurrentUrl} from './router.state';
import {AppState} from '../core.state';
import {select, Store} from '@ngrx/store';
import {take} from 'rxjs/operators';

@Injectable()
export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {

  constructor(private store: Store<AppState>) {}

  serialize(routerState: RouterStateSnapshot): RouterStateUrl {

    let storeCurrentUrl: string = null;

    this.store.pipe(
        take(1),
        select(SelectCurrentUrl)
    ).subscribe((currentUrl) => storeCurrentUrl = currentUrl);

    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams }
    } = routerState;
    const { params } = route;

    const prevUrl: string = storeCurrentUrl;

    return { url, params, queryParams, prevUrl};
  }
}
